var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSelect(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 6C1.55 6 2 5.55 2 5C2 4.45 1.55 4 1 4C0.45 4 0 4.45 0 5C0 5.55 0.45 6 1 6Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 10C1.55 10 2 9.55 2 9C2 8.45 1.55 8 1 8C0.45 8 0 8.45 0 9C0 9.55 0.45 10 1 10Z",
    fill: "#212121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 2C1.55 2 2 1.55 2 1C2 0.45 1.55 0 1 0C0.45 0 0 0.45 0 1C0 1.55 0.45 2 1 2Z",
    fill: "#212121"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 6H15C15.55 6 16 5.55 16 5C16 4.45 15.55 4 15 4H5C4.45 4 4 4.45 4 5C4 5.55 4.45 6 5 6Z",
    fill: "#212121"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10H15C15.55 10 16 9.55 16 9C16 8.45 15.55 8 15 8H5C4.45 8 4 8.45 4 9C4 9.55 4.45 10 5 10Z",
    fill: "#212121"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4 1C4 1.55 4.45 2 5 2H15C15.55 2 16 1.55 16 1C16 0.45 15.55 0 15 0H5C4.45 0 4 0.45 4 1Z",
    fill: "#212121"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelect);
export default __webpack_public_path__ + "static/media/Select.bab744413d9d02b77928ab30ee0730fa.svg";
export { ForwardRef as ReactComponent };